import { ConnectionDetails, QueryInputType, convertConnectionToDetails, handleError, queryInput } from '@/utils/custom';
import {
  ManifestHistoryWithRoute,
  ManifestHistoryWithRouteConnection,
  ManifestHistoryWithRouteConnectionInput,
  ManifestHistoryWithRouteSearch,
} from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { SearchManifestHistoryWithRouteDocument } from '@/api/queries';
import graphApi from '@/api';

export type SearchManifestHistoryWithRouteGraphApiResponse = GraphApiResponse<typeof SearchManifestHistoryWithRouteDocument>;
export type SearchManifestHistoryWithRouteOptions = { pageSize?: number; page?: number; merge?: true };

export const SEARCH_MANIFEST_HISTORY_WITH_ROUTE_PAGE_SIZE = 1000;
const title = 'Search Manifest History With Route';

export const searchManifestHistoryWithRouteResponseSelector = (
  res: SearchManifestHistoryWithRouteGraphApiResponse
): ConnectionDetails<ManifestHistoryWithRoute> =>
  convertConnectionToDetails(res?.searchManifestHistoryWithRoute?.manifestHistoryWithRouteConnection as ManifestHistoryWithRouteConnection);

const [runSearchManifestHistoryWithRoute, runRefetchSearchManifestHistoryWithRoute] = graphApi(SearchManifestHistoryWithRouteDocument, {
  onError: (res: SearchManifestHistoryWithRouteGraphApiResponse): void => handleError(res, { notification: { title } }),
});

export const searchManifestHistoryWithRoute = async (
  query?: ManifestHistoryWithRouteSearch[],
  options: SearchManifestHistoryWithRouteOptions = {}
): Promise<ConnectionDetails<ManifestHistoryWithRoute>> => {
  const { pageSize = SEARCH_MANIFEST_HISTORY_WITH_ROUTE_PAGE_SIZE, page = 0 } = options;

  query = query?.map((q) => ({ routeDeletedAt: queryInput([], QueryInputType.ISNULL), ...q })) || [];
  const input: ManifestHistoryWithRouteConnectionInput = {
    first: pageSize || null,
    after: pageSize ? (pageSize * page).toString() : null,
    query,
  };

  const res = await runRefetchSearchManifestHistoryWithRoute({ input });

  return searchManifestHistoryWithRouteResponseSelector(res);
};

export default searchManifestHistoryWithRoute;
